export default __webpack_public_path__ + "e2611c356bf805b499b09ac95d772e49.jpg";